// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"177":"home","535":"login"}[chunkId] + "." + {"177":"01d20a71","535":"f04a972d"}[chunkId] + ".js";
};